module GenerateStepper {
    const STEPS = ['step-upload', 'step-validate', 'step-save'];
    const LABELS = ['Priprema', 'Generiranje', 'Preuzimanje'];

    function setStep(stepId: string, state: string): void {
        STEPS.forEach(id => {
            if (id === stepId) document.getElementById(id).className = 'step ' + state;
        });
    }

    function setStatus(msg: string, type: string = ''): void {
        let bar = document.getElementById('status-bar');
        bar.className = 'status-bar' + (type ? ' ' + type : '');
        let spin = type === 'loading' ? '<div class="stepper-spinner"></div>' : '';
        bar.innerHTML = `${spin}<span>${msg}</span>`;
    }

    function applyLabels(): void {
        STEPS.forEach((id, i) => {
            let el = document.getElementById(id);
            if (el) {
                let labelEl = el.querySelector('.step-label');
                if (labelEl) labelEl.textContent = LABELS[i];
            }
        });
    }

    export function Show(): void {
        applyLabels();
        STEPS.forEach(id => { document.getElementById(id).className = 'step'; });
        setStatus('Na čekanju...');
        let btn = document.getElementById('stepperCloseBtn') as HTMLButtonElement;
        if (btn) btn.style.display = 'none';
        $('#uploadStepper').show();
        $('#stepperOverlay').show();
    }

    export function Hide(): void {
        $('#uploadStepper').hide();
        $('#stepperOverlay').hide();
    }

    export function Preparing(): void {
        setStep('step-upload', 'active');
        setStatus('Priprema podataka...', 'loading');
    }

    export function Generating(): void {
        setStep('step-upload', 'done');
        setStep('step-validate', 'active');
        setStatus('Generiranje skripti...', 'loading');
    }

    export function Downloading(): void {
        setStep('step-validate', 'done');
        setStep('step-save', 'active');
        setStatus('Preuzimanje arhive...', 'loading');
    }

    export function Done(fileName: string): void {
        setStep('step-save', 'done');
        setStatus(`Datoteka ${fileName} uspješno preuzeta!`, 'success');

        let bar = document.getElementById('stepperCountdown') as HTMLElement;
        bar.style.background = '#1D9E75';
        bar.style.display = 'block';
        bar.style.transition = 'none';
        bar.style.width = '100%';
        bar.offsetWidth;
        bar.style.transition = 'width 2s linear';
        bar.style.width = '0%';

        setTimeout(() => {
            bar.style.display = 'none';
            bar.style.width = '100%';
            window.location.href = '/Dashboard';
        }, 2000);
    }

    export function UpdateStatus(msg: string, type: string = 'loading'): void {
        setStatus(msg, type);
    }

    export function Error(msg: string): void {
        let active = STEPS.find(id => document.getElementById(id).classList.contains('active'));
        if (active) setStep(active, 'error');
        setStatus(msg || 'Greška pri generiranju.', 'error');

        let btn = document.getElementById('stepperCloseBtn') as HTMLButtonElement;
        btn.style.display = 'block';
        btn.onclick = () => {
            btn.style.display = 'none';
            Hide();
        };
    }
}

module PlsWait {
    export function ShowLoader(show: boolean) {
        let loader = $(".loader-wrapper-cube");

        if (show) {
            loader.removeClass("d-none").addClass("show");
        } else {
            // remove .show to fade out wrapper
            loader.removeClass("show");

            // delay d-none until fade-out completes
            setTimeout(() => loader.addClass("d-none"), 400); // slightly longer than cube animation
        }
    }

    export function ShowStepper(show: boolean) {
        if (show) {
            UploadStepper.Show();
        } else {
            UploadStepper.Hide();
        }
    }
}

module UploadStepper {
    function setStep(stepId: string, state: string): void {
        ['step-upload', 'step-validate', 'step-save'].forEach(id => {
            if (id === stepId) document.getElementById(id).className = 'step ' + state;
        });
    }

    function setStatus(msg: string, type: string = ''): void {
        let bar = document.getElementById('status-bar');
        bar.className = 'status-bar' + (type ? ' ' + type : '');
        let spin = type === 'loading' ? '<div class="stepper-spinner"></div>' : '';
        bar.innerHTML = `${spin}<span>${msg}</span>`;
    }

    export function Show(): void {
        ['step-upload', 'step-validate', 'step-save'].forEach(id => {
            document.getElementById(id).className = 'step';
        });
        setStatus('Na čekanju...');
        $('#uploadStepper').show();
        $('#stepperOverlay').show();
    }

    export function Hide(): void {
        $('#uploadStepper').hide();
        $('#stepperOverlay').hide();
    }

    export function Uploading(): void {
        setStep('step-upload', 'active');
        setStatus('Prijenos skripte...', 'loading');
    }

    export function Validating(): void {
        setStep('step-upload', 'done');
        setStep('step-validate', 'active');
        setStatus('Validacija i AI analiza...', 'loading');
    }

    export function Saving(): void {
        setStep('step-validate', 'done');
        setStep('step-save', 'active');
        setStatus('Spremanje skripte...', 'loading');
    }

    export function Done(scriptName: string): void {
        setStep('step-save', 'done');
        setStatus(`Skripta ${scriptName} uspješno spremljena!`, 'success');

        let bar = document.getElementById('stepperCountdown') as HTMLElement
        bar.style.background = '#1D9E75';
        bar.style.display = 'block';
        bar.style.transition = 'none';
        bar.style.width = '100%';
        bar.offsetWidth;
        bar.style.transition = 'width 2s linear';
        bar.style.width = '0%';

        setTimeout(() => {
            bar.style.display = 'none';
            bar.style.width = '100%';
            Hide();
            $('#ScriptModal').one('hidden.bs.modal', function () {
                ScriptsPerCustomer.RefreshTableData();
            });
            $('#ScriptModal').modal('hide');
        }, 2000);
    }

    export function Error(msg: string): void {
        let active = ['step-upload', 'step-validate', 'step-save'].find(id => document.getElementById(id).classList.contains('active'));
        if (active) setStep(active, 'error');
        setStatus(msg || 'Greška pri uploadu.', 'error');

        let btn = document.getElementById('stepperCloseBtn') as HTMLButtonElement;
        btn.style.display = 'block';
        btn.onclick = () => {
            btn.style.display = 'none';
            Hide();
        };
    }
}
